import React, { useState, useRef, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import ChatIcon from '@material-ui/icons/Chat'
import CloseIcon from '@material-ui/icons/Close'
import SendIcon from '@material-ui/icons/Send'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

var SUGGESTIONS = [
  'Most expensive service?',
  'Sessions with cart activity?',
  'Peak usage hours?',
  'Avg cost per session?',
]

var useStyles = makeStyles(function() {
  return {
    panel: {
      position: 'fixed',
      bottom: 74,
      right: 20,
      zIndex: 1300,
      width: 316,
      height: 450,
      background: 'rgba(255,255,255,0.98)',
      border: '1px solid rgba(99,102,241,0.15)',
      borderRadius: 18,
      boxShadow: '0 20px 60px rgba(99,102,241,0.15), 0 4px 16px rgba(0,0,0,0.08)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    panelHeader: {
      padding: '10px 12px',
      borderBottom: '1px solid rgba(99,102,241,0.08)',
      background: 'linear-gradient(135deg, rgba(99,102,241,0.06), rgba(139,92,246,0.04))',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexShrink: 0,
    },
    botIcon: {
      width: 28, height: 28, borderRadius: 9, flexShrink: 0,
      background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      boxShadow: '0 2px 8px rgba(99,102,241,0.35)',
      fontSize: 14,
    },
    headerTitle: { fontSize: 12, fontWeight: 700, color: '#1a2540', lineHeight: 1 },
    headerSub: { fontSize: 10, color: '#999', marginTop: 2 },
    iconBtn: { padding: 4, color: '#bbb', '&:hover': { color: '#6366f1', background: 'rgba(99,102,241,0.07)' } },
    body: {
      flex: 1,
      overflowY: 'auto',
      padding: '10px 10px 4px',
      display: 'flex',
      flexDirection: 'column',
      gap: 7,
    },
    emptyState: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 10,
      padding: '8px 2px',
    },
    suggestionBtn: {
      padding: '6px 10px',
      borderRadius: 8,
      cursor: 'pointer',
      textAlign: 'left',
      background: '#f8faff',
      border: '1px solid #e8ecf4',
      color: '#555',
      fontSize: 11,
      fontWeight: 500,
      transition: 'all 0.13s',
      '&:hover': { background: 'rgba(99,102,241,0.06)', borderColor: 'rgba(99,102,241,0.22)', color: '#6366f1' },
    },
    userBubble: {
      maxWidth: '84%', padding: '7px 11px',
      borderRadius: '13px 13px 3px 13px',
      background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
      color: '#fff',
      fontSize: 12, lineHeight: 1.55,
      whiteSpace: 'pre-wrap', wordBreak: 'break-word',
      alignSelf: 'flex-end',
    },
    botBubble: {
      maxWidth: '84%', padding: '7px 11px',
      borderRadius: '13px 13px 13px 3px',
      background: '#f8faff',
      border: '1px solid #e8ecf4',
      color: '#1a2540',
      fontSize: 12, lineHeight: 1.55,
      whiteSpace: 'pre-wrap', wordBreak: 'break-word',
      alignSelf: 'flex-start',
    },
    errBubble: {
      maxWidth: '84%', padding: '7px 11px',
      borderRadius: '13px 13px 13px 3px',
      background: 'rgba(251,113,133,0.07)',
      border: '1px solid rgba(251,113,133,0.2)',
      color: '#c0392b',
      fontSize: 12, lineHeight: 1.55,
      whiteSpace: 'pre-wrap', wordBreak: 'break-word',
      alignSelf: 'flex-start',
    },
    typingDots: {
      padding: '8px 12px',
      borderRadius: '13px 13px 13px 3px',
      background: '#f8faff',
      border: '1px solid #e8ecf4',
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      alignSelf: 'flex-start',
    },
    inputRow: {
      padding: '8px 10px',
      borderTop: '1px solid rgba(99,102,241,0.07)',
      display: 'flex',
      gap: 6,
      alignItems: 'flex-end',
      flexShrink: 0,
    },
    textarea: {
      flex: 1,
      resize: 'none',
      border: '1px solid #e0e0e0',
      borderRadius: 9,
      padding: '7px 10px',
      background: '#fff',
      color: '#1a2540',
      fontSize: 12,
      outline: 'none',
      lineHeight: 1.4,
      fontFamily: 'inherit',
      maxHeight: 72,
      overflowY: 'auto',
    },
    sendBtn: {
      width: 32, height: 32, borderRadius: 9, flexShrink: 0,
      border: 'none', cursor: 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.15s',
    },
    fab: {
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: 1301,
      width: 48,
      height: 48,
      borderRadius: '50%',
      border: 'none',
      background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 20px rgba(99,102,241,0.42)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow: '0 6px 26px rgba(99,102,241,0.55)',
      },
    },
    dot: {
      width: 5, height: 5, borderRadius: '50%', background: '#818CF8',
    },
    noKeyNotice: {
      padding: '9px 11px', borderRadius: 10,
      background: 'rgba(251,113,133,0.07)',
      border: '1px solid rgba(251,113,133,0.18)',
      color: '#c0392b', fontSize: 11, lineHeight: 1.5,
    },
  }
})

function getOpenAIKey() {
  return localStorage.getItem('lf_openai_key') || ''
}

function buildContext(data, rangeDays) {
  if (!data) return 'No dashboard data loaded yet.'
  var kpis = data.kpis
  var svcTotals = data.svcTotals
  var svcLatencies = data.svcLatencies
  var topSessions = data.topSessions
  var hourlyActivity = data.hourlyActivity
  var weekdayActivity = data.weekdayActivity
  var sessions = data.sessions || []

  var allSessions = sessions.map(function(s) {
    return {
      id: s.id,
      date: s.startTime ? s.startTime.toISOString().slice(0, 10) : null,
      cost: parseFloat((s.totalCost || 0).toFixed(5)),
      dur: parseFloat((s.durationMin || 0).toFixed(2)),
      turns: s.turnCount || 0,
      stt: parseFloat(((s.serviceCosts && s.serviceCosts.stt) || 0).toFixed(5)),
      tts: parseFloat(((s.serviceCosts && s.serviceCosts.tts) || 0).toFixed(5)),
      llm: parseFloat(((s.serviceCosts && s.serviceCosts.llm) || 0).toFixed(5)),
      cart: s.addedToCart || false,
      checkout: s.checkedOut || false,
      user: s.userId || null,
    }
  })

  return JSON.stringify({
    rangeDays: rangeDays,
    kpis: kpis,
    svcTotals: svcTotals,
    svcLatencies: svcLatencies,
    topSessions: (topSessions || []).map(function(s) {
      return { id: s.id, cost: parseFloat((s.totalCost || 0).toFixed(5)), turns: s.turnCount }
    }),
    hourlyActivity: hourlyActivity,
    weekdayActivity: weekdayActivity,
    sessions: allSessions,
  })
}

function systemPrompt(ctx) {
  return 'You are a concise analytics assistant in a Voice Agent dashboard. Use ONLY the data below. Costs are USD. Latencies in ms. Durations in minutes. Be brief — 1-3 sentences max unless a list is needed. Never invent numbers.\n\n' + ctx
}

export default function VoiceChatBubble(props) {
  var classes = useStyles()
  var data = props.data
  var rangeDays = props.rangeDays || 7

  var [open, setOpen] = useState(false)
  var [messages, setMessages] = useState([])
  var [input, setInput] = useState('')
  var [loading, setLoading] = useState(false)
  var bottomRef = useRef(null)
  var inputRef = useRef(null)

  var apiKey = getOpenAIKey()
  var hasKey = Boolean(apiKey)

  useEffect(function() {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages, loading])

  useEffect(function() {
    if (open && inputRef.current) {
      var t = setTimeout(function() { inputRef.current && inputRef.current.focus() }, 60)
      return function() { clearTimeout(t) }
    }
  }, [open])

  function handleSend() {
    var text = input.trim()
    var key = getOpenAIKey()
    if (!text || loading || !key) return

    var history = messages.concat([{ role: 'user', content: text }])
    setMessages(history)
    setInput('')
    setLoading(true)

    var body = JSON.stringify({
      model: 'gpt-4o-mini',
      messages: [{ role: 'system', content: systemPrompt(buildContext(data, rangeDays)) }].concat(history),
      temperature: 0.2,
      max_tokens: 400,
    })

    fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + key },
      body: body,
    })
      .then(function(res) {
        if (!res.ok) {
          return res.json().catch(function() { return {} }).then(function(e) {
            throw new Error((e.error && e.error.message) || ('HTTP ' + res.status))
          })
        }
        return res.json()
      })
      .then(function(json) {
        var content = (json.choices && json.choices[0] && json.choices[0].message && json.choices[0].message.content) || '(empty)'
        setMessages(function(m) { return m.concat([{ role: 'assistant', content: content }]) })
      })
      .catch(function(err) {
        setMessages(function(m) { return m.concat([{ role: 'assistant', content: '⚠️ ' + err.message, error: true }]) })
      })
      .finally(function() {
        setLoading(false)
      })
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  var sessionCount = (data && data.sessions && data.sessions.length) || 0
  var canSend = Boolean(input.trim()) && !loading && hasKey

  return (
    <>
      {/* Chat panel */}
      {open && (
        <div className={classes.panel}>
          {/* Header */}
          <div className={classes.panelHeader}>
            <div className={classes.botIcon}>🤖</div>
            <div style={{ flex: 1 }}>
              <div className={classes.headerTitle}>Assistant</div>
              <div className={classes.headerSub}>
                {hasKey ? sessionCount + ' sessions loaded' : 'OpenAI key missing — add in Settings'}
              </div>
            </div>
            {messages.length > 0 && (
              <IconButton size="small" className={classes.iconBtn} onClick={function() { setMessages([]) }} title="Clear chat">
                <DeleteOutlineIcon style={{ fontSize: 15 }} />
              </IconButton>
            )}
            <IconButton size="small" className={classes.iconBtn} onClick={function() { setOpen(false) }}>
              <CloseIcon style={{ fontSize: 15 }} />
            </IconButton>
          </div>

          {/* Body */}
          <div className={classes.body}>
            {/* No API key notice */}
            {!hasKey && (
              <div className={classes.noKeyNotice}>
                Add your OpenAI API key in the <strong>Settings</strong> tab to enable the assistant.
              </div>
            )}

            {/* Empty state with suggestions */}
            {hasKey && messages.length === 0 && (
              <div className={classes.emptyState}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: 40, height: 40, borderRadius: 13, margin: '0 auto 8px',
                    background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.14)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 20,
                  }}>🤖</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#1a2540', marginBottom: 2 }}>Ask about your data</div>
                  <div style={{ fontSize: 10, color: '#aaa' }}>Try one of these</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                  {SUGGESTIONS.map(function(q) {
                    return (
                      <button
                        key={q}
                        className={classes.suggestionBtn}
                        onClick={function() { setInput(q); if (inputRef.current) inputRef.current.focus() }}
                      >
                        {q}
                      </button>
                    )
                  })}
                </div>
              </div>
            )}

            {/* Messages */}
            {messages.map(function(m, i) {
              return (
                <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
                  <div className={m.error ? classes.errBubble : m.role === 'user' ? classes.userBubble : classes.botBubble}>
                    {m.content}
                  </div>
                </div>
              )
            })}

            {/* Typing dots */}
            {loading && (
              <div style={{ display: 'flex' }}>
                <div className={classes.typingDots}>
                  {[0, 1, 2].map(function(i) {
                    return (
                      <div
                        key={i}
                        className={classes.dot}
                        style={{
                          animation: 'chatBounce 1.1s ' + (i * 0.18) + 's ease-in-out infinite',
                        }}
                      />
                    )
                  })}
                </div>
              </div>
            )}

            <div ref={bottomRef} />
          </div>

          {/* Input */}
          <div className={classes.inputRow}>
            <textarea
              ref={inputRef}
              className={classes.textarea}
              value={input}
              rows={1}
              placeholder={hasKey ? 'Ask anything…' : 'API key required'}
              disabled={!hasKey || loading}
              onChange={function(e) { setInput(e.target.value) }}
              onKeyDown={handleKeyDown}
              onFocus={function(e) { e.target.style.borderColor = 'rgba(99,102,241,0.38)' }}
              onBlur={function(e) { e.target.style.borderColor = '#e0e0e0' }}
            />
            <button
              className={classes.sendBtn}
              onClick={handleSend}
              disabled={!canSend}
              style={{
                background: canSend ? 'linear-gradient(135deg, #6366F1, #8B5CF6)' : '#f5f5f5',
                cursor: canSend ? 'pointer' : 'not-allowed',
                boxShadow: canSend ? '0 3px 10px rgba(99,102,241,0.32)' : 'none',
              }}
            >
              {loading
                ? <CircularProgress size={13} style={{ color: '#aaa' }} />
                : <SendIcon style={{ fontSize: 13, color: canSend ? '#fff' : '#ccc' }} />
              }
            </button>
          </div>
        </div>
      )}

      {/* Floating action button */}
      <button
        className={classes.fab}
        onClick={function() { setOpen(function(o) { return !o }) }}
        onMouseOver={function(e) { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 6px 26px rgba(99,102,241,0.55)' }}
        onMouseOut={function(e) { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(99,102,241,0.42)' }}
      >
        <div style={{ transition: 'transform 0.2s ease', transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>
          {open
            ? <CloseIcon style={{ color: '#fff', fontSize: 20 }} />
            : <ChatIcon style={{ color: '#fff', fontSize: 20 }} />
          }
        </div>
      </button>

      {/* Bounce keyframe injected once */}
      <style>{`
        @keyframes chatBounce {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </>
  )
}
